import React from 'react';
import AdminComponent from 'components/webinar/admin';

export default function Admin() {
  return <AdminComponent />;
}
